// Story 8.5 (ADO-2014), D-20: one Depot Switcher option's cut-off pill. `useHeaderChrome`
// renders it into the panel's per-option slot (`renderOptionCutOff`), since a hook cannot
// run inside the panel's list and the design system does no fetching. The read is the
// shared one (`useDepotCutOff`), so the header chip for the same cart costs nothing more.
// Story 8.4 (ADO-2013): the option's cart is its depot AND its account, so each Value Centre
// account's row shows its own cut-off. The cut-off is read per depot and account (Enabler E8-G,
// ADO-3109), so the Chill and Fruit & Veg rows share one read.

import { CutOffPill, type CutOffPillSize } from '../../design-system';
import type { CartAccount } from '../../api/cart-target';
import { useDepotCutOff } from '../../basket/useDepotCutOff';

export function SwitcherOptionCutOff({
  cart,
  size,
}: {
  readonly cart: CartAccount;
  readonly size: CutOffPillSize;
}) {
  const cutOff = useDepotCutOff(cart);
  return <CutOffPill {...cutOff} size={size} />;
}
